import { render } from "./Systemverwaltung.vue?vue&type=template&id=d3897b66&scoped=true"
import script from "./Systemverwaltung.vue?vue&type=script&lang=js"
export * from "./Systemverwaltung.vue?vue&type=script&lang=js"

import "./Systemverwaltung.vue?vue&type=style&index=0&id=d3897b66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3897b66"]])

export default __exports__